import { render, staticRenderFns } from "./eduContinueData.vue?vue&type=template&id=504e22b0&"
import script from "./eduContinueData.vue?vue&type=script&lang=js&"
export * from "./eduContinueData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports